













import Vue from 'vue'

export default Vue.extend({
    name: 'rd-drawer',
    props: {
        title: {default: ''},
        visible: {type: Boolean},
        closeable: {default: true},
        placement: {default: 'left'},
        width: {default: ''},
        height: {default: ''},
        mask: {default: true}
    },
    data() { return {
        display: false
    }},
    mounted() {
        this.display = this.visible;
        (<HTMLElement>this.$el).style.setProperty('--rd-drawer-width', this.drawerWidth);
        (<HTMLElement>this.$el).style.setProperty('--rd-drawer-height', this.drawerHeight);
    },
    methods: {
        displayHeader(): boolean {
            return (this.title?.length > 0 || this.closeable)
        }
    },
    computed: {
        drawerHeight(): string {
            if (['left', 'right'].includes(this.placement))
                return this.height || '100%'
            else
                return this.height || '256px'
        },
        drawerWidth(): string {
            if (['left', 'right'].includes(this.placement))
                return this.width || '256px'
            else
                return this.width || '100%'
        }
    },
    watch: {
        visible(newVal, oldVal) {
            this.display = newVal
        }
    }
})
